// src/router/job.router.ts
import type { RouteRecordRaw } from 'vue-router'

export const jobRoutes: RouteRecordRaw[] = [
  {
    path: 'job',
    name: 'job',
    component: () => import('@/views/page/job/JobData.vue'),
    meta: { title: 'Job' },
  },
  {
    path: 'job/trash',
    name: 'job-trash',
    component: () => import('@/views/page/job/JobData.vue'),
    meta: { title: 'Job Trash' },
  },
  {
    path: 'job/create/:ticketId?',
    name: 'job-create',
    component: () => import('@/views/page/job/JobInput.vue'),
    meta: { title: 'Create Job' },
  },
  {
    path: 'job/:id/edit',
    name: 'job-edit',
    component: () => import('@/views/page/job/JobInput.vue'),
    meta: { title: 'Edit Job' },
  },
  {
    path: 'job/:id/print',
    name: 'job-print',
    component: () => import('@/views/page/job/JobPrint.vue'),
    meta: { title: 'Print Job' },
  },
]
